import { useReduxLoading } from '@core/hooks';
import MailModal from 'app/main/mail';
import { VendaContext } from 'app/main/venda/VendaContext';
import { vendaApi } from 'app/services/api/vendaApi';
import * as Actions from 'app/store/actions';
import { eventReactGA } from 'app/utils/analyticsUtil';
import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { VendaModais } from '../VendaModais';

const VENDA = 'Venda';

const OrcamentoMail = () => {
  const [idVendaAtual] = useContext(VendaContext).idVendaAtual;
  const [modal, setModal] = useContext(VendaContext).modal;
  const [loading, setLoading] = useContext(VendaContext).loading;
  const [templateMailOrcamento] = useContext(VendaContext).templateMailOrcamento;
  const [email, setEmail] = useContext(VendaContext).email;

  const dispatch = useDispatch();

  useReduxLoading(loading);

  const showSuccess = (message) => {
    dispatch(Actions.showMessage({ message, variant: 'success' }));
  };

  const showError = (message) => {
    dispatch(Actions.showMessage({ message, variant: 'error' }));
  };

  const handleCloseModal = () => {
    setModal(false);
  };

  const sendEmail = async (emails, assunto) => {
    eventReactGA(VENDA, 'Enviar orçamento por e-mail');
    const mailRequest = {
      registroId: idVendaAtual,
      assunto,
      emails,
    };

    let response;
    setLoading(true);

    try {
      response = await vendaApi().enviarOrcamento(mailRequest);
      showSuccess('E-mail enviado com sucesso.');
    } catch (error) {
      if (error?.response?.data?.errorKey === 'parametros-email.not-found') {
        showError('Para envio de e-mails é necessário informar os dados do remetente nos Parâmetros de E-mail');
      } else if (error?.response?.data?.errorKey === 'email-invalido') {
        showError(error?.response?.data?.message);
      } else {
        showError('Houve um erro ao enviar o e-mail.');
      }
    }

    setLoading(false);
    return response;
  };

  return (
    <MailModal
      open={modal === VendaModais.enviarOrcamento}
      handleCloseModal={handleCloseModal}
      sendEmail={sendEmail}
      templateMail={templateMailOrcamento}
      email={email}
      setEmail={setEmail}
    />
  );
};

export default OrcamentoMail;
